import styled from "@emotion/styled";

export const DetailsSection = styled.div`
	margin-top: 1.5rem;
`;

export const FieldsContainer = styled.div`
	display: flex;
	flex-direction: column;
`;

export const ButtonsContainer = styled.div`
	display: flex;
	gap: 0.5rem;
`;
